// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"623e1b63","455":"b0b1c9a6"}[chunkId] + ".chunk.js";
};